import { createWebHistory, createRouter } from 'vue-router'
import Auth from '../layouts/Auth.vue'
import Authenticated from '/@/layouts/Authenticated.vue'
import { authRouteGuard, disabledRouteGuard } from './guards'

// import('/@/views/recordings/list.vue')

// import('/@/views/settings/index.vue')

const routes = [
  {
    path: '/auth',
    component: Auth,
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('/@/views/Login.vue'),
      },
    ],
  },
  {
    path: '',
    component: Authenticated,
    children: [
      { path: '/', name: 'Home', component: () => import('/@/views/Home.vue') },
      {
        path: '/channels',
        name: 'ChannelList',
        component: () => import('/@/views/channels/ChannelList.vue'),
      },
      {
        path: '/channels/create',
        name: 'ChannelCreate',
        component: () => import('../views/channels/ChannelForm.vue'),
      },
      {
        path: '/channels/:id/',
        component: () => import('/@/views/channels/ChannelPage.vue'),
        children: [
          {
            path: '',
            name: 'ChannelDashboard',
            component: () => import('/@/views/channels/ChannelDashboard.vue'),
          },
          {
            path: 'outcomes',
            name: 'ChannelOutcomes',
            component: () => import('/@/views/channels/ChannelOutcomes.vue'),
          },
          {
            path: 'flow-inbound',
            name: 'ChannelFlowInbound',
            component: () => import('/@/views/channels/ChannelFlow.vue'),
          },
          {
            path: 'flow-outbound',
            name: 'ChannelFlowOutbound',
            component: () => import('/@/views/channels/ChannelFlow.vue'),
          },
          {
            path: 'update',
            name: 'ChannelUpdate',
            component: () => import('/@/views/channels/ChannelForm.vue'),
          },
        ],
      },
      {
        path: '/campaigns',
        name: 'CampaignList',
        component: () => import('/@/views/campaigns/CampaignList.vue'),
      },
      {
        path: '/campaigns/create',
        name: 'CampaignCreate',
        component: () => import('../views/campaigns/CampaignForm.vue'),
      },
      {
        path: '/campaigns/:id/',
        component: () => import('/@/views/campaigns/CampaignPage.vue'),
        children: [
          {
            path: 'lists',
            name: 'Lists',
            component: () => import('/@/views/campaigns/Lists.vue'),
          },
          {
            path: 'recycle',
            name: 'Recycle',
            component: () => import('/@/views/campaigns/Recycle.vue'),
          },
          {
            path: 'lists/create',
            name: 'ListCreate',
            component: () => import('../views/campaigns/ListForm.vue'),
          },
          {
            path: 'lists/:listId',
            name: 'ListUpdate',
            component: () => import('../views/campaigns/ListForm.vue'),
          },
          {
            path: 'lists/:listId/refresh',
            name: 'ListRefresh',
            component: () => import('../views/campaigns/RefreshList.vue'),
          },
          {
            path: 'dispositions',
            name: 'CampaignDispositions',
            component: () =>
              import('/@/views/campaigns/CampaignDispositions.vue'),
          },
          {
            path: 'update',
            name: 'CampaignUpdate',
            component: () => import('/@/views/campaigns/CampaignForm.vue'),
          },
        ],
      },
      {
        path: '/recordings',
        name: 'RecordingList',
        component: () => import('/@/views/recordings/list.vue'),
      },
      {
        path: '/reports',
        name: 'ReportList',
        component: () => import('/@/views/reports/ReportList.vue'),
      },
      {
        path: '/reports/:id',
        name: 'ReportView',
        component: () => import('/@/views/reports/ReportView.vue'),
      },
      {
        path: '/forms',
        name: 'FormList',
        component: () => import('/@/views/forms/FormList.vue'),
      },
      {
        path: '/forms/create',
        name: 'FormCreate',
        component: () => import('../views/forms/Form.vue'),
      },
      {
        path: '/forms/:id',
        name: 'FormUpdate',
        component: () => import('../views/forms/Form.vue'),
      },
      {
        path: '/forms/:id/answers',
        name: 'FormAnswers',
        component: () => import('../views/forms/FormAnswers.vue'),
      },
      {
        path: '/mailbox/',
        name: 'Mailbox',
        component: () => import('../views/channelMailbox/ChannelMailboxPage.vue'),
        children: [
          {
            path: '',
            name: 'AssignedList',
            component: () => import('../views/channelMailbox/assigned/AssignedList.vue'),
          },
          {
            path: 'unassigned',
            name: 'UnassignedList',
            component: () => import('../views/channelMailbox/unassigned/UnassignedList.vue'),
          }
        ],
      },
      {
        path: '/address-book',
        name: 'AddressBookList',
        component: () => import('/@/views/addressBook/AddressBookList.vue'),
      },
      {
        path: '/address-book/create',
        name: 'AddressBookCreate',
        component: () => import('/@/views/addressBook/AddressBookForm.vue'),
      },
      {
        path: '/address-book/:id',
        name: 'AddressBookUpdate',
        component: () => import('/@/views/addressBook/AddressBookForm.vue'),
      },
      {
        path: '/workflows',
        name: 'WorkflowList',
        component: () => import('/@/views/workflows/WorkflowList.vue'),
      },
      {
        path: '/workflows/create',
        name: 'WorkflowCreate',
        component: () => import('../views/workflows/Form.vue'),
      },
      {
        path: '/workflows/:id',
        name: 'WorkflowUpdate',
        component: () => import('../views/workflows/Form.vue'),
      },
      {
        path: '/workflows/:id/traces',
        name: 'WorkflowTraces',
        component: () => import('../views/workflows/WorkflowTraces.vue'),
      },
      {
        path: '/workflows/:id/traces/:traceId',
        name: 'WorkflowTraceDetails',
        component: () => import('../views/workflows/WorkflowTraceDetails.vue'),
      },
      {
        path: '/tokens',
        name: 'TokensList',
        component: () => import('/@/views/apiTokens/TokensList.vue'),
      },
      {
        path: '/plugin/:pluginRoute(.*)*',
        name: 'PluginView',
        component: () => import('/@/views/plugin/PluginView.vue'),
      },
      {
        path: '/queues',
        name: 'QueueList',
        component: () => import('/@/views/queues/QueueList.vue'),
      },
      {
        path: '/queues/create',
        name: 'QueueCreate',
        component: () => import('../views/queues/QueueForm.vue'),
      },
      {
        path: '/queues/:id/',
        component: () => import('/@/views/queues/QueuePage.vue'),
        children: [
          {
            path: '',
            name: 'QueueUpdate',
            component: () => import('/@/views/queues/QueueForm.vue'),
          },
          {
            path: 'flow-inbound',
            name: 'QueueFlowInbound',
            component: () => import('/@/views/queues/QueueFlow.vue'),
          },
          {
            path: 'flow-outbound',
            name: 'QueueFlowOutbound',
            component: () => import('/@/views/queues/QueueFlow.vue'),
          },
        ],
      },
      {
        path: '/dashboards/',
        name: 'dashboards',
        component: () => import('../views/dashboards/DashboardPage.vue'),
        children: [
          {
            path: '',
            name: 'DashboardList',
            component: () => import('../views/dashboards/DashboardList.vue'),
          },
          {
            path: 'create',
            name: 'DashboardCreate',
            component: () => import('../views/dashboards/DashboardCreator.vue'),
          },
          {
            path: ':id',
            name: 'DashboardUpdate',
            component: () => import('../views/dashboards/DashboardCreator.vue'),
          },
          {
            path: ':id/view',
            name: 'DashboardView',
            component: () => import('../views/dashboards/DashboardView.vue'),
          },
        ],
      },
      {
        path: '/settings/',
        name: 'Settings',
        component: () => import('../views/settings/SettingsPage.vue'),
        children: [
          {
            path: '',
            name: 'UserList',
            component: () => import('../views/settings/users/UserList.vue'),
          },
          {
            path: 'users/create',
            name: 'UserCreate',
            component: () => import('../views/settings/users/UserForm.vue'),
          },
          {
            path: 'users/:id',
            name: 'UserUpdate',
            component: () => import('../views/settings/users/UserForm.vue'),
          },
          {
            path: 'plugins',
            name: 'PluginList',
            component: () => import('../views/settings/plugins/PluginList.vue'),
          },
          {
            path: 'plugins/:id',
            name: 'PluginUpdate',
            component: () => import('../views/settings/plugins/PluginForm.vue'),
          },
          {
            path: 'pause-codes',
            name: 'PauseList',
            component: () =>
              import('../views/settings/pauseCodes/PauseList.vue'),
          },
          {
            path: 'pause-codes/create',
            name: 'PauseCreate',
            component: () =>
              import('../views/settings/pauseCodes/PauseForm.vue'),
          },
          {
            path: 'pause-codes/:id',
            name: 'PauseUpdate',
            component: () =>
              import('../views/settings/pauseCodes/PauseForm.vue'),
          },
          {
            path: 'extensions',
            name: 'ExtensionList',
            component: () =>
              import('../views/settings/extensions/ExtensionList.vue'),
          },
          {
            path: 'extensions/create',
            name: 'ExtensionCreate',
            component: () =>
              import('../views/settings/extensions/ExtensionForm.vue'),
          },
          {
            path: 'extensions/:id',
            name: 'ExtensionUpdate',
            component: () =>
              import('../views/settings/extensions/ExtensionForm.vue'),
          },
          {
            path: 'teams',
            name: 'TeamList',
            component: () => import('../views/settings/teams/TeamList.vue'),
          },
          {
            path: 'teams/create',
            name: 'TeamCreate',
            component: () => import('../views/settings/teams/TeamForm.vue'),
          },
          {
            path: 'teams/:id',
            name: 'TeamUpdate',
            component: () => import('../views/settings/teams/TeamForm.vue'),
          },
          {
            path: 'roles',
            name: 'RoleList',
            component: () => import('../views/settings/roles/RoleList.vue'),
          },
          {
            path: 'roles/create',
            name: 'RoleCreate',
            component: () => import('../views/settings/roles/RoleForm.vue'),
          },
          {
            path: 'roles/:id',
            name: 'RoleUpdate',
            component: () => import('../views/settings/roles/RoleForm.vue'),
          },
          {
            path: 'trunks',
            name: 'TrunkList',
            component: () => import('../views/settings/trunks/TrunkList.vue'),
          },
          {
            path: 'trunks/:id',
            name: 'TrunkUpdate',
            component: () => import('../views/settings/trunks/TrunkForm.vue'),
          },
          {
            path: 'manualDispositions',
            name: 'ManualDispositions',
            component: () =>
              import('../views/settings/OrganizationDispositions.vue'),
          },
          {
            path: 'userLicenses',
            name: 'UserLicenses',
            component: () => import('../views/settings/UserLicenseTokens.vue'),
          },
          {
            path: 'globalSettings',
            name: 'GlobalSettings',
            component: () =>
              import('../views/settings/OrganizationSettings.vue'),
          },
          {
            path: 'userDevices',
            name: 'UserDeviceList',
            component: () =>
              import('../views/settings/users/UserDevicesList.vue'),
          },
          {
            path: 'users/:userId/userDevices/create',
            name: 'UserDeviceCreate',
            component: () =>
              import('../views/settings/users/UserDeviceForm.vue'),
          },
          {
            path: 'userDevices/:id',
            name: 'UserDeviceUpdate',
            component: () =>
              import('../views/settings/users/UserDeviceForm.vue'),
          },
        ],
      },
      {
        path: '/profile',
        name: 'AgentProfile',
        component: () => import('/@/views/settings/users/AgentProfile.vue'),
      },
    ],
  },
]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach((to, from, next) => {
  if (to.path === '/' && to.name === undefined) {
    next({ name: 'Home' })
  } else {
    next()
  }
})
router.beforeEach(authRouteGuard)
router.beforeEach(disabledRouteGuard)
export default router
